var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.759,
    height: 20.799,
    viewBox: "0 0 19.759 20.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M22.759,17.559V15.48l-8.32-5.2V4.56a1.56,1.56,0,1,0-3.12,0v5.72L3,15.48v2.08l8.32-2.6v5.72l-2.08,1.56V23.8l3.64-1.04,3.64,1.04v-1.56l-2.08-1.56V14.96Z",
    transform: "translate(-3 -3)",
    fill: "#b2b1b1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.da0fd646fbebb589cc55fdb2c4042145.svg";
export { ForwardRef as ReactComponent };